<template>
  <nav v-if="isLoggedIn && !isLogin" class="container-fluid navbar pace-navbar">
    <div class="float-start">
      <template
        v-if="
          getAccessPermission('dashboard_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link to="/">
          <a class="mx-3"><i class="bi bi-box-seam"></i> dashboard</a>
        </router-link>
      </template>
      <template
        v-if="
          getAccessPermission('process_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link :to="{ name: 'ProcessViewV1' }">
          <a class="mx-3">Processes</a>
        </router-link>
        <router-link :to="{ name: 'AuthConfig' }">
          <a class="mx-3">Auth Config</a>
        </router-link>
      </template>
      <template
        v-if="
          getAccessPermission('ctcl_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link :to="{ name: 'CTCLSV1' }">
          <a class="mx-3">CTCLS</a>
        </router-link>
      </template>
      <template
        v-if="
          (getAccessPermission('recon_tab') &&
            (!is_thailand_user || $store.state.user_role?.role == 'admin')) ||
          has_permission_quant
        "
      >
        <router-link :to="{ name: 'Recon' }">
          <a class="mx-3"><i class="bi bi-clock-history"></i> Recon</a>
        </router-link>
      </template>
      <template
        v-if="
          getAccessPermission('ctcl_history_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link :to="{ name: 'CTCLSHistory' }">
          <a class="mx-3">CTCLS History</a>
        </router-link>
      </template>
      <template
        v-if="
          getAccessPermission('file_script_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link :to="{ name: 'Scripts' }">
          <a class="mx-3">Scripts</a>
        </router-link>
      </template>

      <template
        v-if="
          $store.state.user_role?.details?.is_thailand_user ||
          $store.state.user_role?.role == 'admin'
        "
      >
        <router-link :to="{ name: 'Thailand' }">
          <a class="mx-3">KGI</a>
        </router-link>
      </template>
      <template v-if="has_infra_cost_permission">
        <router-link :to="{ name: 'InfraCost' }">
          <a class="mx-3">Infra Cost</a>
        </router-link>
      </template>
      <template
        v-if="
          getAccessPermission('auth_user_tab') &&
          (!is_thailand_user || $store.state.user_role?.role == 'admin')
        "
      >
        <router-link :to="{ name: 'AuthUsers' }">
          <a class="mx-3">AuthUser</a>
        </router-link>
      </template>
      <!-- <router-link :to="{ name: 'UniversalData' }">
        <a class="mx-3"><i class="bi bi-clock-history"></i> Universal</a>
      </router-link> -->
      <!-- <router-link to="/monitor">
        <a class="mx-3"><i class="bi bi-box-seam"></i> monitors</a>
      </router-link> -->
      <!-- <router-link to="/logs">
        <a><i class="bi bi-terminal"></i> logs</a>
      </router-link> -->
    </div>
    <div class="float-end">
      <a v-if="isLoggedIn" class="outline-btn mx-2 time-btn disabled-btn">
        <i class="bi bi-calendar-fill"></i> {{ istTime?.time }}
        {{ istTime?.day }} {{ istTime?.date }}</a
      >
      <a v-if="isLoggedIn" class="outline-btn time-btn" v-on:click="logout()"
        >Logout</a
      >
    </div>
  </nav>
  <router-view />
</template>
<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      isLogin: true,
      has_permission: false,
      has_permission2: false,
      has_permission_orders: false,
      istTime: "",
      istTimeInterval: null,
      has_permission3: false,
      groupLoaded: false,
      is_thailand_user: false,
      has_permission_quant: false,
      has_infra_cost_permission: false,
    };
  },
  beforeCreate() {
    this.$store.commit("initializeStore");
    const access_token = this.$store.state.access_token;
    if (access_token) {
      axios.defaults.headers.common["Authorization"] = "Token " + access_token;
    } else {
      // No token, clear the Authorization header
      axios.defaults.headers.common["Authorization"] = "  ";
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      this.isHomepage = to.name === "home";
      next();
    });
    this.$router.beforeEach((to, from, next) => {
      this.isLogin = to.name === "login";
      next();
    });
  },
  mounted() {
    const email = localStorage.getItem("email");
    const access_token = localStorage.getItem("access_token");
    this.has_permission_orders = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "rahuldubey@pacefin.in",
      "utkarshkucchal@pacefin.in",
    ].includes(email);
    this.has_permission_orders = true;
    this.has_permission = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "shreyansh@pacefin.in",
      "rahuldubey@pacefin.in",
      "jatinpandey@pacefin.in",
    ].includes(email);
    this.has_permission2 = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "shreyansh@pacefin.in",
      "rahuldubey@pacefin.in",
      "jatinpandey@pacefin.in",
      "nikhilgupta@pacefin.in",
      "japjeet@pacefin.in",
    ].includes(email);

    this.updateISTTime();
    if (access_token) {
      this.istTimeInterval = setInterval(this.updateISTTime, 1000);
      this.getUserRole();
    }
    this.has_permission3 = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "shreyansh@pacefin.in",
      "rahuldubey@pacefin.in",
      "jatinpandey@pacefin.in",
      "utkarshkucchal@pacefin.in",
    ].includes(email);
    this.has_infra_cost_permission = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "rahuldubey@pacefin.in",
      "utkarshkucchal@pacefin.in",
    ].includes(email);
    this.has_permission_quant = [
      "ramneekbhatia@pacefin.in",
      "chaitanyaagarwal@pacefin.in",
      "abhishekrajgarhia@delvegacapital.com",
      "parvindersingh@pacefin.in",
      "kanavgupta@pacefin.in",
      "aishwaryjoshi@pacefin.in",
      "dhruvgoel@pacefin.in",
      "priyagupta@pacefin.in",
      "keshavjha@pacefin.in",
      "nikhilgupta@pacefin.in",
      "deepanshubansal@pacefin.in",
    ].includes(email);
  },
  beforeUnmount() {
    clearInterval(this.istTimeInterval);
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.access_token && this.groupLoaded;
    },
  },
  methods: {
    logout() {
      axios
        .post("/auth/logout/")
        .then(() => {
          // Handle successful logout
          clearInterval(this.istTimeInterval);
          localStorage.removeItem("access_token");
          localStorage.removeItem("reqdlogs");
          sessionStorage.removeItem("reqdlogs");
          localStorage.removeItem("email");
          this.$store.commit("setAccesstoken", null);
          localStorage.clear();
          location.reload();
          this.$router.push("/login");
        })
        .catch((error) => {
          // Handle error
          console.log(error);
        });
    },
    reload() {
      if (this.$route.fullPath != "/ctcl" && this.$route.name == "CtclView") {
        this.$router.push("/ctcl");
        setTimeout(() => {
          location.reload();
        }, 10);
      }
    },
    updateISTTime() {
      const email = localStorage.getItem("email") ?? null;
      axios
        .get(`ctcl/ist-datetime/?username=${email}`)
        .then((response) => {
          this.istTime = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUserRole() {
      axios
        .get("/api/user/groups/")
        .then((response) => {
          console.log(response.data);
          this.$store.commit("setUserRoles", response.data);
          this.groupLoaded = true;
          console.log("states", this.$store.state);
          if (
            response.data?.is_thailand_user &&
            response.data?.role.toLowerCase() != "admin"
          ) {
            this.is_thailand_user = true;
            this.$router.push("/thailand/");
          } else {
            this.is_thailand_user = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.groupLoaded = true;
        });
    },

    getAccessPermission(component_tab = null) {
      let automation = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "recon_tab",
        "ctcl_history_tab",
        "file_script_tab",
        "cost_tab",
      ];
      let admin = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "recon_tab",
        "ctcl_history_tab",
        "auth_user_tab",
        "thailand_tab",
        "file_script_tab",
        "cost_tab",
      ];

      let quant_developer = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "ctcl_history_tab",
      ];
      let quant_team_lead = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "ctcl_history_tab",
      ];
      let tech_team_lead = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "ctcl_history_tab",
        "file_script_tab",
        "cost_tab",
      ];
      let tech_developer = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "ctcl_history_tab",
        "file_script_tab",
        "cost_tab",
      ];
      let network_engineer = [
        "dashboard_tab",
        "process_tab",
        "ctcl_tab",
        "ctcl_history_tab",
        "file_script_tab",
        "cost_tab",
      ];

      let role = this.$store.state.user_role ?? null;
      let is_thailand =
        this.$store.state.user_role?.details?.is_thailand ?? false;

      if (role == null || role?.role == null) {
        return false;
      }
      if (role?.role?.toLowerCase() == "automation") {
        return automation?.includes(component_tab);
      } else if (
        role?.role?.toLowerCase() == "quant developer" &&
        !is_thailand
      ) {
        return quant_developer?.includes(component_tab);
      } else if (
        role?.role?.toLowerCase() == "quant team lead" &&
        !is_thailand
      ) {
        return quant_team_lead?.includes(component_tab);
      } else if (role?.role?.toLowerCase() == "admin") {
        return admin?.includes(component_tab);
      } else if (role?.role?.toLowerCase() == "tech team lead") {
        return tech_team_lead?.includes(component_tab);
      } else if (role?.role?.toLowerCase() == "tech developer") {
        return tech_developer?.includes(component_tab);
      } else if (role?.role?.toLowerCase() == "network engineer") {
        return network_engineer?.includes(component_tab);
      }

      return false;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inconsolata:wght@300&display=swap");
@import url("https://fonts.googleapis.com/css?family=Ubuntu+Mono");
/* Universal section start */
body {
  font-family: "Quicksand";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #415a77 !important;
  background-color: #edf2fb !important;
  letter-spacing: 0.6px;
}
a {
  text-decoration: none !important;
  color: #415a77 !important;
  cursor: pointer !important;
}
a:hover {
  color: #f3756c !important;
}
/* Universal section end */
/* Navbar section start */
.pace-navbar {
  font-size: 18px;
  background-color: #fff;
  padding: 10px 10px !important;
}
.outline-btn {
  font-size: 18px;
  border-style: solid;
  border-width: 2px;
  border-color: #415a77;
  border-radius: 2px;
  padding: 2px 9px;
  letter-spacing: 1px;
}
.outline-btn:hover {
  border-color: #f3756c !important;
  color: #f3756c !important;
}
/* Navbar section end */
/* Header and table css start */
.header h2 {
  font-family: "Inconsolata", monospace;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.5em;
  padding-bottom: 10px;
  position: relative;
}
.header h2:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 5px;
  width: 55px;
  background-color: #f3756c;
}
.header h2:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 2px;
  height: 1px;
  width: 95%;
  max-width: 228px;
  background-color: #f3756c;
}
.header h3 {
  font-family: "Inconsolata", monospace;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.5em;
  padding-bottom: 10px;
  position: relative;
}
.header h3:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 5px;
  width: 55px;
  background-color: #f3756c;
}
.header h3:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 2px;
  height: 1px;
  width: 95%;
  max-width: 170px;
  background-color: #f3756c;
}
.custom-table {
  background-color: #fff;
}
.custom-table th,
.custom-table td {
  padding: 0.6rem 0.2rem !important;
  vertical-align: middle !important;
  text-align: center !important;
  font-size: 15px;
  color: #0d1b2a !important;
  font-weight: 600;
}
.form-check-input[type="checkbox"],
.form-check-input[type="radio"] {
  border-radius: 80% !important;
  border-color: #f3756c !important;
  background-color: #f3756c !important;
  width: 1.3em;
  height: 1.3em;
}
.table-hover tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: #edf2fb;
}
.custom-table tr.red td {
  color: red !important;
}
.custom-table tr.highlighted-row td {
  color: red !important;
}
body.dark-mode .table-hover tbody tr:hover .bg-red {
  background-color: rgb(167, 50, 42) !important;
}
body.dark-mode .table-hover tbody tr .bg-red {
  background-color: rgb(167, 50, 42) !important;
}
.table-hover tbody tr .bg-red {
  background-color: rgb(167, 50, 42) !important;
  color: #fff !important;
}
/* Header and table css end */
.time-btn {
  font-size: 1rem;
  padding: 0.4rem;
  border-radius: 0.6rem;
}
.disabled-btn {
  pointer-events: none;
}
</style>
